/**
 * Created by zhengyf on 2018/2/25.
 */

;(function () {

    SmartEditorCtrl.$inject = ['$timeout', 'editorInfo', 'UploaderConfig', 'event'];
    angular
        .module('DSSXAPP')
        .factory('editorInfo', editorDataService)
        .component('smartEditorComponent', {
            template:'<div class="product-post-component product-post-component-smart-editor"><div class="rbsel-content"><div id="intel-editor"><div class="check-dialog" id="pro-dialog" ng-show="vm.c.checkDialogShow"><div class="mask"></div><div class="dialog"><div class="header">选取详情模板</div><div class="body"><ul class="template-list"><li class="template-item" title="该模板由官方提供"><div class="preview"><img style="width: 118px;height: 98px;" src="images/product-post/bg_muban.jpg"></div><div class="title">通用模板</div></li></ul></div><div class="footer"><button type="button" ng-click="vm.f.editorClose()">取消</button> <button type="button" class="confirm" ng-click="vm.f.editorItemsReset()">选取</button></div></div></div><div class="container"><div class="switchbarmin"><div class="maya-switchbarmin"><span><button class="non-content" ng-click="vm.f.gotoEditorDialog()">立即体验</button> <button class="has-content" ng-click="vm.f.gotoFullScreenEditor()">编辑详情</button> <a class="has-content" ng-click="vm.f.gotoEditorDialog()" style="margin-left: 10px;">重新选择模板</a> <a></a></span></div></div><div class="introduce"></div><div class="preview-content"></div></div><div class="maya-editor" ng-show="vm.c.showEditor"><div class="maya-switchbar"><div class="option"><span class="text">智能编辑</span><div class="zoom"><button type="button" ng-click="vm.f.editDone()">编辑完成</button></div></div></div><div class="content-area"><div class="maya-content"><div class="formatbar"><div class="maya-sidebar" data-role="maya-sidebar"><div class="projects"></div></div></div><div class="detail"><div class="viewport"><div class="richtext maya-viewport"><div class="hi-layout" id="hi-layout"></div></div></div></div><div class="navigatorbar"><div class="maya-sidebar open"><div class="items" id="nav-title-list"><div class="title">我的详情导航 <span class="navmanage-count">({{vm.d.editorInfo.items.length}}/8)</span></div><ul class="navmanage-list"><li id="maya-li-{{$index}}" ng-repeat="item in vm.d.editorInfo.items track by $index" ng-click="vm.f.gotoContent($index)"><span>{{item.title}}</span> <a class="delete-item" ng-click="vm.f.removeItemDialog($index, item, $event)">×</a></li></ul><div class="navmanage-operate"><div class="nav-inputArea" ng-show="vm.c.showAddItemPanel"><div class="ui2-combobox ui2-combobox-normal" data-role="nav-input"><ul class="nav-inputPart util-clearfix"><li><input class="nav-input ui2-textfield ui2-textfield-single ui2-combobox-input" data-role="combobox-input" placeholder="请输入或选择导航" autocomplete="off" ng-model="vm.d.addItemInput" ng-focus="vm.f.displayAddItemList(true)" ng-blur="vm.f.displayAddItemList(false)"></li><li><a class="nav-submit ui2-button ui2-button-default ui2-button-primary ui2-button-medium" ng-click="vm.f.addItemBigConfirm()" href="javascript:void(0);">确定</a></li></ul><div class="ui2-combobox-trigger" data-role="combobox-trigger"></div></div><div data-widget-cid="widget-10" class="ui2-combobox-popup-wrapper" style="z-index: 99; position: absolute;background: #fff;width: 200px;" ng-show="vm.c.showAddItemList"><div class="ui2-popup-menu-list ui2-popup-menu" style="width: 100%" data-role="combobox-popup"><div class="combobox-recommend" data-role="recommend">推荐导航</div><ul class="ui2-popup-menu-flat-items"><li class="ui2-popup-menu-flat-item" ng-repeat="cat in vm.d.defaultItemList track by $index" ng-show="vm.d.addItem.showItem(cat)"><a href="javascript:void(0)" ng-bind="vm.d.defaultItems[cat].title" ng-click="vm.f.addItemBig(vm.d.defaultItems[cat])"></a></li></ul></div></div><div class="nav-tip" ng-show="vm.c.showEngError" style="font-size: 12px;color: #ff7519;">请输入英文字符</div><div class="ui2-combobox-popup-wrapper" data-widget-cid="widget-203" aria-hidden="true" style="display: none; z-index: 99;"><div class="ui2-popup-menu"><ul class="ui2-popup-menu-ctn" data-role="items"></ul></div></div></div><a href="javascript:void(0);" class="nav-add" ng-class="{disabled: vm.d.editorInfo.items.length >= 7}" ng-click="vm.f.itemNew()"><span>+</span>添加导航</a></div></div><div class="projects"></div></div></div></div></div><input type="file" style="display: none" id="editor-file-input"></div></div></div><div class="p-p-dialog" ng-show="vm.c.showDeleteDialog"><div class="p-mask"></div><div class="p-content"><h3>警告</h3><div class="content-m"><div class="c-m-c">删除导航后，该导航下的内容将一并删除，您确定要删除此导航吗？</div><div class="dialog-btn"><input type="button" value="确定" class="ui2-button ui2-button-primary ui2-button-medium" ng-click="vm.f.removeItemBig()"> <input type="button" value="取消" class="ui2-button ui2-button-normal ui2-button-medium" ng-click="vm.c.showDeleteDialog = false;"></div></div></div></div></div>',
            bindings: {

            },
            controllerAs: 'vm',
            controller: SmartEditorCtrl
        });

    function editorDataService() {
        return {
            curFocusDom: null,
            curImgDom: null,
            curProgressBar:null,
            toolsBoard:null,
            preview: '',
            items: null,
            itemMap: {},
            init: function (preview, items) {
                this.preview = preview;
                this.items = items;

                angular.forEach(this.items, function (value, key) {
                    if (!value.type) {
                        value.type = 'other';
                    }
                });

                if (this.preview) {
                    $('.container .introduce').hide();
                    $('.container .preview-content').show();
                    $('.container .preview-content').html(this.preview);
                }
            }
        }
    }

    function SmartEditorCtrl($timeout, editorInfo, UploaderConfig, event) {
        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;
        var util = DSSX.util;

        var d = vm.d = {
            removeItemTmp: null,
            defaultItems: {
                pd: {
                    title: 'Product Description',
                    type: 'pd',
                    items: [
                        {
                            t: 'text',
                            c: '<p style="margin:0;padding:0;"><font style="font-size: 14px; line-height: 22px;">This fabric is a elegant, first class quality satin rosette lace fabric, graceful color</font></p><p style="margin:0;padding:0;"><font style="font-size: 14px; line-height: 22px;"><br>* Rosette lace fabric: available in many colors, you pick up the color <br>* Soft and Romantic.<br>* This fresh lace fabric is perfect for wedding ceremony decoration, apparel, curtain, home decor , new born photo</font><br></p>'
                        },
                        {
                            t: 'text',
                            c: '<table class="easy-table aliDataTable col-header" tabindex="1" data-widget-cid="widget-134" style="width: auto; border-collapse: collapse; word-wrap: break-word;"><tbody><tr><td><div data-role="cellContent" class="easy-table-content" style="width: 166px; height: 22px; padding: 5px 10px; overflow: hidden;"><div data-role="cellEditor" class="easy-table-editor" contenteditable="true"><b>Product Type:</b></div><div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td><td>    <div data-role="cellContent" class="easy-table-content" style="width: 537px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor">Lace</div>    <div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td></tr><tr><td>    <div data-role="cellContent" class="easy-table-content" style="width: 166px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor"><b>Material:</b></div><div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td><td>    <div data-role="cellContent" class="easy-table-content" style="width: 537px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor">Nylon / Cotton</div>    <div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td></tr><tr><td>    <div data-role="cellContent" class="easy-table-content" style="width: 166px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor"><b>Fabric Type:</b></div><div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td><td>    <div data-role="cellContent" class="easy-table-content" style="width: 537px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor">Mesh</div>    <div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td></tr><tr><td>    <div data-role="cellContent" class="easy-table-content" style="width: 166px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor"><b>Technics:</b></div><div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td><td>    <div data-role="cellContent" class="easy-table-content" style="width: 537px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor">Embroidered</div>    <div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td></tr><tr><td>    <div data-role="cellContent" class="easy-table-content" style="width: 166px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor"><b>Feature:</b></div><div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td><td>    <div data-role="cellContent" class="easy-table-content" style="width: 537px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor">Eco-Friendly, Water Soluble, Other</div><div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td></tr><tr><td>    <div data-role="cellContent" class="easy-table-content" style="width: 166px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor"><b>Decoration:&nbsp;</b></div><div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td><td class="">    <div data-role="cellContent" class="easy-table-content" style="width: 537px; height: auto; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor" contenteditable="true" style="min-height: 22px;">Sequins</div>    <div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td></tr><tr><td>    <div data-role="cellContent" class="easy-table-content" style="width: 166px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor"><b>Color:</b></div><div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td><td>    <div data-role="cellContent" class="easy-table-content" style="width: 537px; height: 22px; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor">Red</div>    <div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td></tr><tr><td>    <div data-role="cellContent" class="easy-table-content" style="width: 166px; height: auto; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor" contenteditable="true" style="min-height: 22px;"><b>Width:</b></div><div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td><td class="">    <div data-role="cellContent" class="easy-table-content" style="width: 537px; height: auto; padding: 5px 10px; overflow: hidden;">    <div data-role="cellEditor" class="easy-table-editor" contenteditable="true" style="min-height: 22px;">120cm</div><div class="easy-table-dragger" data-control-cid="control-0">    <div data-role="rowDragger" class="easy-table-dragger-row"></div>    <div data-role="colDragger" class="easy-table-dragger-col"></div>    </div></div>    </td></tr></tbody></table>'
                        },
                        {
                            t: 'image',
                            c: ''
                        },
                        {
                            t: 'image',
                            c: ''
                        },
                        {
                            t: 'image',
                            c: ''
                        }
                    ]
                },
                rp: {
                    title: 'Related Products',
                    type: 'rp',
                    items: [
                        {
                            t: 'image',
                            c: '',
                        },
                        {
                            t: 'image',
                            c: '',
                        },
                        {
                            t: 'image',
                            c: '',
                        }
                    ]
                },
                cp: {
                    title: 'Company Profile',
                    type: 'cp',
                    items: [
                        {
                            t: 'image',
                            c: ''
                        },
                        {
                            t: 'text',
                            c: '<p style="margin:0;padding:0;"><font style="font-size: 14px; line-height: 22px;">The company mainly to do what, how many people, how many classification products, can show the strength of serveral aspects, whether the advantages of productions logistics process and after-sales service. What kind of products are displayed.</font></p>'
                        },
                        {
                            t: 'image',
                            c: ''
                        },
                    ]
                },
                e: {
                    title: 'Exhibition',
                    type: 'e',
                    items: [
                        {
                            t: 'image',
                            c: ''
                        },
                        {
                            t: 'text',
                            c: '<p style="margin:0;padding:0;"><font style="font-size: 14px; line-height: 22px;">The company mainly to do what, how many people, how many classification products, can show the strength of serveral aspects, whether the advantages of productions logistics process and after-sales service. What kind of products are displayed.</font></p>'
                        },
                    ]
                },
                oa: {
                    title: 'Our Advantages',
                    type: 'oa',
                    items: [
                        {
                            t: 'image',
                            c: ''
                        },
                        {
                            t: 'image',
                            c: ''
                        },
                        {
                            t: 'image',
                            c: ''
                        },
                        {
                            t: 'text',
                            c: '<p style="margin:0;padding:0;"><font style="font-size: 14px; line-height: 22px;">The company mainly to do what, how many people, how many classification products, can show the strength of serveral aspects, whether the advantages of productions logistics process and after-sales service. What kind of products are displayed.</font></p>'
                        },
                    ]
                },
                c: {
                    title: 'Certifications',
                    type: 'c',
                    items: [
                        {
                            t: 'image',
                            c: ''
                        },
                    ]
                },
                pnd: {
                    title: 'Packing & Delivery',
                    type: 'pnd',
                    items: [
                        {
                            t: 'image',
                            c: '',
                            //n: '2'
                        },
                        {
                            t: 'text',
                            c: '<p style="margin:0;padding:0;"><font style="font-size: 14px; line-height: 22px;">The company mainly to do what, how many people, how many classification products, can show the strength of serveral aspects, whether the advantages of productions logistics process and after-sales service. What kind of products are displayed.</font></p>',
                            //n: '2'
                        },
                    ]
                },
            },
            defaultItemList: ['pd','rp','cp','e','oa','c','pnd',],
            editorInfo: editorInfo,
            addItemInput: '',
            addItem: {
                curSelected: null,
                showItem: function (type) {
                    var item = d.defaultItems[type];
                    if (!d.editorInfo.itemMap[type] && item.title.toLowerCase().indexOf(vm.d.addItemInput.toLowerCase()) > -1) {
                        return true;
                    }
                    return false;
                }
            }
        };

        var f = vm.f = {
            itemNew: function () {
                if (d.editorInfo.items.length >= 7) {
                    return;
                }
                c.showAddItemPanel = true;
                c.showEngError = false;
                d.addItemInput = '';
            },
            resetDeleteItem: function () {
                d.editorInfo.itemMap = {};
                angular.forEach(d.editorInfo.items, function (value, key) {
                    if (value.type !== 'other') {
                        d.editorInfo.itemMap[value.type] = true;
                    }
                });
            },
            removeItemDialog: function (index, item, event) {
                d.removeItemTmp = {
                    index: index,
                    item: item
                };
                c.showDeleteDialog = true;
                event.stopPropagation();
            },
            removeItemBig: function () {
                if (!d.removeItemTmp) {
                    return;
                }
                var index = d.removeItemTmp.index;
                var item = d.removeItemTmp.item;
                d.editorInfo.items.splice(index, 1);
                if (item.type && item.type !== 'other') {
                    d.editorInfo.itemMap[item.type] = false;
                }
                c.showDeleteDialog = false;
                f.refEditorView();
            },
            addItemBig: function (item) {
                d.addItemInput = item.title;
                c.showEngError = false;
                d.addItem.curSelected = item;
            },
            addItemBigConfirm: function () {
                if (!d.addItemInput) {
                    return;
                }
                if (!/[\x00-\xff]+/g.test(d.addItemInput)) {
                    c.showEngError = true;
                    return;
                }
                var _item = angular.copy(d.addItem.curSelected);
                d.addItem.curSelected = null;
                _item.title = d.addItemInput;
                d.editorInfo.items.push(_item);
                c.showAddItemList = false;
                c.showAddItemPanel = false;
                f.resetDeleteItem();
                f.refEditorView();
            },
            refEditorView: function () {

               // 格式化数据，否则无法进行后续操作
                if(editorInfo.preview && editorInfo.preview !== '' && editorInfo.preview !== '123'){
                  $('#hi-layout').html(editorInfo.preview);
                  editorInfo.items = this.getEditorDataItems();
                }

                $('#hi-layout').html('');
                // $('#nav-title-list > .navmanage-list').html('');
                var isRowThreeImg = true;
                var isOurAdvan = true;
                for (var i = 0; i < editorInfo.items.length; i++) {
                    // $('#nav-title-list > .navmanage-list').append('<li id="maya-li-' + i + '"><span>' + editorInfo.items[i].title + '</span><a class="delete-item" onclick="removeItemBig(this)">×</a></li>');

                    var child = '';

                    for (var j = 0; j < editorInfo.items[i].items.length; j++) {
                        var _item = editorInfo.items[i].items[j];
                        if (_item.t === 'text') {
                            child += '<div class="box-content" onclick="editorFunc.focusBox(this)"><div class="editor-inline">' + _item.c + '</div> </div>';
                        }
                        if (_item.t === 'image') {
                            if (editorInfo.items[i].title === 'Related Products' && isRowThreeImg) {
                                isRowThreeImg = false;
                                var temp1 = '<div class="box-image" onclick="editorFunc.focusBox(this)" style="margin-right:5px;">' +
                                    '<div class="tool">' +
                                    '<div class="tool-bg">' +
                                    '<a onclick="editorFunc.changeImage(this)">从本地选择图片</a>' +
                                    '</div>' +
                                    '</div>' +
                                    '<div class="content" style="width:485px;height:316px;position:relative;overflow:hidden;">' +
                                    '<img src="' + (editorInfo.items[i].items[0].c || 'imgs/editor-6-1.png') + '" style="width: 485px;height:317px;position:absolute;bottom:0;left:0;">' +
                                    '</div>' +
                                    '</div>';
                                var temp2 = '<div class="box-image" onclick="editorFunc.focusBox(this)" style="margin: 0;padding:0;">' +
                                    '<div class="tool" style="height:100%;margin-top:-10px;">' +
                                    '<div class="tool-bg">' +
                                    '<a onclick="editorFunc.changeImage(this)">从本地选择图片</a>' +
                                    '</div>' +
                                    '</div>' +
                                    '<div class="content" style="width:245px;height:156px;position:relative;overflow:hidden;">' +
                                    '<img src="' + (editorInfo.items[i].items[1].c || 'imgs/editor-6-2.png') + '" style="width: 245px;position:absolute;left:0;bottom:0;">' +
                                    '</div>' +
                                    '</div>';
                                var temp3 = '<div class="box-image" onclick="editorFunc.focusBox(this)" style="margin: 0;padding:0;padding-top:4px;">' +
                                    '<div class="tool" style="height:100%;margin-top:-8px;">' +
                                    '<div class="tool-bg">' +
                                    '<a onclick="editorFunc.changeImage(this)">从本地选择图片</a>' +
                                    '</div>' +
                                    '</div>' +
                                    '<div class="content" style="width:245px;height:156px;position:relative;overflow:hidden;">' +
                                    '<img src="' + (editorInfo.items[i].items[2].c || 'imgs/editor-6-3.png') + '" style="width: 245px;position:absolute;left:0;bottom:0;">' +
                                    '</div>' +
                                    '</div>';
                                var tmp = '<div>' + '<div style="display:inline-block;">' + temp1 + '</div>' + '<div style="display:inline-block;margin:10px 0;padding:10px 0;">' + temp2 + temp3 + '</div>' + '</div>';
                                child += tmp;
                            }
                            if (editorInfo.items[i].title === 'Our Advantages' && isOurAdvan) {
                                isOurAdvan = false;
                                var temp4 = '<div class="box-image" onclick="editorFunc.focusBox(this)" style="display:inline-block;margin-right:0;">' +
                                    '<div class="tool" style="height:100%;margin-top:-10px;">' +
                                    '<div class="tool-bg">' +
                                    '<a onclick="editorFunc.changeImage(this)">从本地选择图片</a>' +
                                    '</div>' +
                                    '</div>' +
                                    '<div class="content" style="width:240px;height:234px;position:relative;overflow:hidden;">' +
                                    '<img src="' + (editorInfo.items[i].items[0].c || 'imgs/editor-7-10.png') + '" style="width: 240px;position:absolute;left:0;bottom:0;right:0;top:0;margin:auto;">' +
                                    '</div>' +
                                    '</div>';
                                var temp5 = '<div class="box-image" onclick="editorFunc.focusBox(this)" style="display:inline-block;margin-left:5px;margin-right:0;">' +
                                    '<div class="tool" style="height:100%;margin-top:-8px;">' +
                                    '<div class="tool-bg">' +
                                    '<a onclick="editorFunc.changeImage(this)">从本地选择图片</a>' +
                                    '</div>' +
                                    '</div>' +
                                    '<div class="content" style="width:240px;height:234px;position:relative;overflow:hidden;">' +
                                    '<img src="' + (editorInfo.items[i].items[1].c || 'imgs/editor-7-2.png') + '" style="width: 240px;position:absolute;left:0;bottom:0;right:0;top:0;margin:auto;">' +
                                    '</div>' +
                                    '</div>';
                                var temp6 = '<div class="box-image" onclick="editorFunc.focusBox(this)" style="display:inline-block;margin-left:5px;margin-right:0;">' +
                                    '<div class="tool" style="height:100%;margin-top:-8px;">' +
                                    '<div class="tool-bg">' +
                                    '<a onclick="editorFunc.changeImage(this)">从本地选择图片</a>' +
                                    '</div>' +
                                    '</div>' +
                                    '<div class="content" style="width:240px;height:234px;position:relative;overflow:hidden;">' +
                                    '<img src="' + (editorInfo.items[i].items[2].c || 'imgs/editor-7-3.png') + '" style="width: 240px;position:absolute;left:0;bottom:0;right:0;top:0;margin:auto;">' +
                                    '</div>' +
                                    '</div>';
                                var tmp2 = '<div>' + temp4 + temp5 + temp6 + '</div>';
                                child += tmp2;
                            }
                            if (editorInfo.items[i].title !== 'Related Products' && editorInfo.items[i].title !== 'Our Advantages') {
                                child += '<div class="box-image" onclick="editorFunc.focusBox(this)">' +
                                    '<div class="tool">' +
                                    '<div class="tool-bg">' +
                                    '<a onclick="editorFunc.changeImage(this)">从本地选择图片</a>' +
                                    '</div>' +
                                    '</div>' +
                                    '<div class="content">' +
                                    '<img src="' + (_item.c || 'imgs/editor-05.png') + '" style="width: 750px;">' +
                                    '</div>' +
                                    '</div>';
                            }

                        }
                    }

                    $('#hi-layout').append('<div class="hi-content" id="maya-c-' + i + '" ef-type="' + editorInfo.items[i].type + '"><div class="box-title"><span contenteditable="true">' + editorInfo.items[i].title + '</span></div>' + child + '</div>');
                }

                $('.box-image').each(function () {
                    $(this).mouseover(function () {
                        $(this).find('.tool').show();
                    });
                    $(this).mouseout(function () {
                        if($(this).find('.tool').attr("uploading") == 1){
                            return;
                        }
                        $(this).find('.tool').hide();
                    });
                });

                f.initUploader();

                tinymce.init({
                    selector: '.editor-inline',
                    inline: true,
                    object_resizing: false,
                    menubar: false,
                    plugins: "link,textcolor",
                    toolbar: 'fontselect fontsizeselect | bold italic underline | forecolor | alignleft aligncenter alignright | subscript superscript | link | removeformat'
                });

                $(".tool-bg").append('<div style="position: relative;margin: 0px auto;width: 80%"><progress max="100" style="margin-top: 30px;height: 7px;width: 100%"></progress></div>');

            },
            displayAddItemList: function (show) {
                $timeout(function () {
                    c.showAddItemList = show;
                }, 300);
            },
            gotoFullScreenEditor: function () {
                if (!editorInfo.preview) {
                    f.gotoEditorDialog();
                    return;
                }

                f.resetDeleteItem();

                vm.c.showEditor = true;
                $('body').css({ overflow: 'hidden' });
                
                f.refEditorView();
            },
            gotoEditorDialog: function () {
                c.checkDialogShow = true;
                c.showEditor = true;

                f.resetDeleteItem();
                $('body').css({ overflow: 'hidden' });
            },
            editDone: function () {
                editorInfo.preview = f.getEditorDataPreview();
                editorInfo.items = f.getEditorDataItems();
                // if (editorInfo.preview.indexOf("imgs/editor-05.png") > -1) {
                //     layer.msg('请替换掉示例图片');
                //     return;
                // }

                c.showEditor = false;
                $('body').css({ overflow: '' });
                $('.container .introduce').hide();
                $('.maya-switchbarmin .non-content').hide();
                $('.maya-switchbarmin .has-content').show();
                $('.container .preview-content').show();
                $('.container .preview-content').html(editorInfo.preview);
                event.emit('smart-editor-close');
            },
            getEditorDataPreview: function () {
                $('.maya-editor .remove-box').remove();
                var html = $('#hi-layout').html().replace(/contenteditable="true"/g, '').replace(/onclick/g, '').replace(/active-sealed/g, '');
                return html;
            },
            getEditorDataItems: function () {
                var rs = [];
                $('#hi-layout').children().each(function (key, obj) {
                    var _content = {
                        title: $(obj).find('.box-title > span')[0].innerText,
                        type: obj.getAttribute('ef-type'),
                        items: []
                    };
                    $(obj).find('div').each(function (i, item) {
                        if ($(item).hasClass('box-content')) {
                            _content.items.push({
                                t: 'text',
                                c: $(item).find('.mce-content-body').html()
                            });
                        }
                        if ($(item).hasClass('box-image')) {
                            _content.items.push({
                                t: 'image',
                                c: $(item).find('.content img')[0].src
                            });
                        }
                    });
                    rs.push(_content);
                });
                return rs;
            },
            initUploader: function () {
                var inputId = 'editor-file-input';

                var uploadInput = $('#' + inputId);

                var clearFile = function() {
                    uploadInput.wrap('<form></form>');
                    uploadInput.parent()[0].reset();
                    uploadInput.unwrap();
                };

                uploadInput.change(function () {

                    if (this.files.length == 0) {
                        return;
                    }

                    var curImgDom = editorInfo.curImgDom;
                    var toolBoard = editorInfo.toolsBoard;

                    toolBoard.attr("uploading","1");

                    var progressBar = editorInfo.curProgressBar;

                    var config = UploaderConfig.getConfig();
                    config.onSuccess = function (obj, data) {
                        curImgDom.src = data.data;
                        progressBar.fadeOut(800);
                        toolBoard.fadeOut(800);
                        toolBoard.removeAttr("uploading");
                        clearFile();
                    };
                    config.onProcess = function (obj, link) {
                        editorInfo.curProgressBar.show();
                        var perc = obj.rate;
                        if(perc>=100){
                            perc = 100;
                        }
                        editorInfo.curProgressBar.val(perc);
                    };
                    config.onError = function (obj, link) {
                        layer.msg('上传失败，请重试');
                        clearFile();
                    };
                    var loader = new uploadFactory(config);

                    loader.add(this.files);
                });
            },
            editorItemsReset: function () {
                editorInfo.preview = '123';
                c.checkDialogShow = false;
                editorInfo.items = [];
                angular.forEach(d.defaultItemList, function (value, key) {
                    editorInfo.items.push(d.defaultItems[value]);
                });
                f.gotoFullScreenEditor();
            },
            editorClose: function () {
                c.checkDialogShow = false;
                c.showEditor = false;
                $('body').css({ overflow: '' });
            },
            gotoContent: function (index) {
                $timeout(function () {
                    $('.detail .viewport').scrollTo('#maya-c-' + index, 500);
                });
            }
        };

        var c = vm.c = {
            reg: {
                ascii: /[\x00-\xff]+/g
            },
            showEditor: false,
            checkDialogShow: false,
            showAddItemList: false,
            showAddItemPanel: false,
            showEngError: false,
            showDeleteDialog: false,
        };

        function onInit() {
            console.log('[SmartEditorCtrl init: ]');

            window.editorFunc = {
                focusBox: function (e) {
                    editorInfo.curFocusDom = e;
                    $('.maya-editor .remove-box').remove();
                    $(e).append('<img src="imgs/editor-06.png" class="remove-box" onclick="editorFunc.removeItemLittle()">');
                    $('.box-content').removeClass('active-sealed');
                    $(e).addClass('active-sealed');
                },
                changeImage: function (ele) {
                    editorInfo.curImgDom = $(ele).parents('.box-image').find('.content img')[0];

                    editorInfo.curProgressBar = $($(ele).parents('.box-image').find('progress')[0]);
                    editorInfo.toolsBoard = $($(ele).parents('.box-image').find('.tool')[0]);

                    var uploadInput = $("#editor-file-input");
                    uploadInput.click();
                },
                removeItemLittle: function () {
                    $(editorInfo.curFocusDom).remove();
                }
            }
        }

        function bindingsOnChanges() {

        }


    }

})();
